module.exports = __webpack_public_path__ + "img/chinesecompany30.af4e67bc.png";